<ng-container>
  <a
    (click)="submitTripsForm()"
    aria-label="Trip Details redirects to manage my trips page"
    class="idp-global-nav-trip-detail-description"
    data-cy="backToTripDetails"
    href="javascript:void(0)"
  >
    <span class="idp-global-nav-trip-icon">
      <img
        class="idp-global-nav-trip-detail-description"
        [attr.src]="nextgenReshopHeaderData.headerIcon"
        [attr.alt]="alternativeText ? alternativeText : null"
      />
    </span>
    {{ nextgenReshopHeaderData.headerlabel }}
  </a>
  <form
    #findTripForm
    [action]="alternateFlow.link"
    method="POST"
    name="findTripForm"
    novalidate
  >
    <input
      *ngIf="findTripData?.confirmationNo"
      name="confirmationNo"
      type="hidden"
      value="{{ findTripData.confirmationNo }}"
    />
    <input
      *ngIf="findTripData?.firstName"
      name="firstName"
      type="hidden"
      value="{{ findTripData.firstName }}"
    />
    <input
      *ngIf="findTripData?.lastName"
      name="lastName"
      type="hidden"
      value="{{ findTripData.lastName }}"
    />
    <input
      *ngIf="findTripData?.returnAction"
      name="returnAction"
      type="hidden"
      value="{{ findTripData.returnAction }}"
    />
    <input
      *ngIf="findTripData?.originalSource"
      name="originalSource"
      type="hidden"
      value="{{ findTripData.originalSource }}"
    />
    <input
      *ngIf="findTripData?.interstitial"
      name="interstitial"
      type="hidden"
      value="{{ findTripData.interstitial }}"
    />
  </form>
</ng-container>
